var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnnounce({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.227 13.321l1.638-1.147 2.98-7.023a1 1 0 011.74-.183L14 8.418c1.001-.533 2.326-.167 3.064.887.738 1.055.63 2.425-.213 3.183l2.415 3.45a1 1 0 01-.767 1.572l-7.62.398-1.637 1.147a1 1 0 01-1.393-.245L4.98 14.714a1 1 0 01.246-1.393zm3.912-1.386l2.744 3.918 4.71-.246-5.611-8.014-1.843 4.342zm.594 4.335l-1.721-2.458-.82.574 1.722 2.457.819-.573z"
  })));
}

export default SvgAnnounce;